import { Text } from '@/components/ui';
import { Role } from '@console/utils';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

interface RoleBadgeProps {
  role: Role;
}

export function RoleBadge({ role }: RoleBadgeProps) {
  const { t } = useTranslation();

  const roleClasses: Record<Role, string> = {
    ADMIN: 'bg-neutral-strong text-base-white',
    VIEWER: 'bg-neutral-muted text-base-white',
    TIME_TRACKER: 'bg-neutral-subtle text-neutral-muted',
  };

  return (
    <Text
      as="span"
      variant="label"
      size="xs"
      strong
      className={clsx('py-5xs px-3xs rounded-full', roleClasses[role])}
    >
      {t(`common.roles.${role}`)}
    </Text>
  );
}
